import React, { useEffect, useState } from "react";
import { Button, Input, Modal, Select } from "antd";
import TableAction from "../../components/TableAction";
import OrdersTable from "../../components/tables/order/OrdersTable";
import WithAuth from "../../hoc/WithAuth";
import InputModal from "../../components/modals/InputModal";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";

function InputPage() {
  const { user } = useAuth() as AuthContextValue;
  const [searchText, setSearchText] = useState<string>("");
  const [selectedId, setSelectedId] = useState<string>("");
  const [open, setOpen] = useState(false);

  const handleCreate = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <div
      className="bg-transparent px-2 md:bg-white md:px-[50px]"
      style={{
        borderRadius: 8.5,
        marginTop: 25,
        paddingTop: 22,
      }}
    >
      <InputModal open={open} selectedId={selectedId} hideModal={hideModal} />
      <div
        className="hidden md:flex"
        style={{
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction
          setSearchText={setSearchText}
          onCreateNew={
            user?.roleName === "ROLE_OFF_TAKER_ADMIN" ? handleCreate : undefined
          }
        />
      </div>
      <div className="text-white sticky top-0">
        <Input
          onChange={(e) => setSearchText(e.target.value)}
          placeholder="Search"
          style={{ backgroundColor: "transparent", color: "white", height: 40 }}
        />
      </div>
      <OrdersTable searchText={searchText} />
    </div>
  );
}

export default WithAuth(InputPage);
